import { minLength, maxLength, required, email, numeric, url } from 'vuelidate/lib/validators';

// global max length that overrides user settings
const systemMaxLength = {
  text: 125,
  textArea: 1000,
}

export default class FieldValidation {
  constructor(validator, field) {
    this.validator = validator;
    this.field = field;
  }

  get minLength() {
    if (this.validator.minLength != null) {
      return minLength(this.validator.minLength);
    }
    return false;
  }

  get maxLength() {
    const maxLengthWithDefault = this.systemMaxLength
    if (maxLengthWithDefault) {
      return maxLength(maxLengthWithDefault);
    }

    if (this.validator.maxLength != null) {
      return maxLength(this.validator.maxLength);
    }
    return false;
  }

  get required() {
    if (this.validator.required !== null) {
      return this.validator.required;
    }
    return false;
  }

  get fieldTypeValidator() {
    if (this.field.type === 'email') {
      return email;
    }
    if (this.field.type === 'number') {
      return numeric;
    }
    return true;
  }

  get validationObject() {
    const validationObject = {};
    validationObject.value = {};
    if (this.required) {
      validationObject.value = { required };
    }
    if (this.minLength) {
      validationObject.value.minLength = this.minLength;
    }
    if (this.maxLength) {
      validationObject.value.maxLength = this.maxLength;
    }
    if (this.field.type === 'email') {
      validationObject.value.email = email;
    }
    if (this.field.type === 'url') {
      validationObject.value.url = url;
    }
    return validationObject;
  }

  /**
   * Returns the max length also considering a 'global sytem' max
   */
  get systemMaxLength() {
    if (this.field.type in systemMaxLength &&
      (this.validator.maxLength == null || this.validator.maxLength > systemMaxLength[this.field.type])) {
      return systemMaxLength[this.field.type];
    }

    return undefined;
  }
}
